package com.eladfinish.bible.contest.screens.completeVerse.usecases

import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.screens.completeVerse.model.VersePart

class GetHalfVerseUseCase {

    operator fun invoke(
        pasuk: String,
        part: VersePart,
    ): String {
        val index = getIndexOfSpaceAfterTaamMafsik(pasuk)
        return when (part) {
            VersePart.BEFORE_ATNACHTA -> pasuk.take(index)
            VersePart.AFTER_ATNACHTA -> pasuk.substring(index)
        }.replaceRegex(regex = "\\s+", replacement = " ").trim()
    }

    private fun getIndexOfSpaceAfterTaamMafsik(
        pasuk: String,
    ): Int {
        val ole = '֫'
        val yored = '֥'
        val atnachta = '֑'
        val zaqefQaton = '֔'
        val tarcha = '֖'
        val ravia = '֗'
        val teamim = charArrayOf(ole, atnachta, zaqefQaton, tarcha, ravia)
        var middle = 0
        for (t in teamim) {
            if (pasuk.lastIndexOf(t).also { middle = it } != -1) {
                //                int temp = middle - 2;
                if (t != ole || pasuk.indexOf(yored, middle).also { middle = it } != -1) {
                    break
                }
            }
        }
        return pasuk.indexOf(" ", middle)
    }

}
